import { useLocation, useNavigate } from "react-router-dom";
import { Hbrbackarrow } from "./newComponents/Mycustomsvgicons";
import appIcon from "./otherImg/hbrlitenewicon.png";

const AboutPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const closePage=()=>{
    if (location.state && location.state.from) {
        navigate(location.state.from);
    }else{
        navigate("/");
    }
  };

    return (
        <div className="about-page">
             <div className="about">
                <div className="flex-row2" style={{width:"100%", gap:"10px"}}>
                  <Hbrbackarrow width={"2em"} height={"2em"} fillColour={"white"} handleClick={()=>closePage()}/>
                  <h2 style={{color:"white"}}>About</h2>
                </div>
              
                <img src={appIcon} alt="App Logo" title ="Logo for Horemow Book Reader App"/>
                <p>Current features: <br/><br/>horemow books, <br/>Daily devotion,<br/> Bible commentary,<br/> videos & audio messages,<br/> chat system,<br/> social blog,<br/> live streaming,<br/> bible quiz <br/> <br/>

                  THIS SOFTWARE IS DEVELOPED TO ALIGN WITH THE GOALS OF THE MOVEMENT BY PROMOTING BIBLICAL RIGHTEOUSNESS, AND HOLINESS IN CHURCHES AND NATIONS OF THE WORLD THROUGH CRUSADES, CONFERENCES, REVIVAL MEETINGS, PRODUCTION AND SPREAD OF HOLINESS LITERATURE AND MATERIALS. <br/><br/>
                  Purpose of production: ,<br /> TO SERVE AS A LONGSTANDING BACKUP TO hard copy books. <br/> TO SERVE AS A SOUL WINNING METHOD THROUGH CYBER EVANGELISM.
                </p> <br/><br/>
                  
                  <p>connect with us.</p><br/><br/>
                
                <ul>
                  <li><a href="mailto:holinessrevivalmovement@gmail.com">Email us</a></li>
                  <li><a href="https://web.facebook.com/pastorpaulrika/" >Facebook Page</a></li>  
                  <li><a href="https://youtube.com/c/PASTORPAULRIKA1" >Follow us on Youtube</a> </li>
                  <li> <a href="https://www.instagram.com/officialpastorpaulrika" >Follow us on Instagram</a> </li> 

              </ul> 
             </div>
            
            <div className="policy">
              <h2 style={{color:"white"}}>Privacy Policy</h2>
              <p>HBR Team built the Horemow Book Reader LiTE web app as a Free app. This SERVICE is provided by the HBR Team at no cost and is intended for use as is. 
                This page is used to inform visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service. 
                If you choose to use our Service, then you agree to the collection and use of information in relation to this policy. 
                The Personal Information that we collect is used for providing and improving the Service. 
                we will not use or share your information with anyone except as described in this Privacy Policy. 
                The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions unless otherwise defined in this Privacy Policy. <br/><br/>
                <strong style={{color:"white"}}>Information Collection and Use: </strong> <br/><br/>
                For a better experience, while using our Service, we may require you to provide 
                us with certain personally identifiable information. The information that we 
                request will be retained on your device. <br/><br/>

                <strong style={{color:"white"}}>Cookies</strong><br/><br/>
                Cookies are files with a small amount of data that are commonly used as 
                anonymous unique identifiers. These are sent to your browser from the 
                websites that you visit and are stored on your device's internal memory. 
                This Service does not use these "cookies" explicitly. However, the app may 
                use third-party code and libraries that use "cookies" to collect information and 
                improve their services. You have the option to either accept or refuse these 
                cookies and know when a cookie is being sent to your device. If you choose to 
                refuse our cookies, you may not be able to use some portions of this Service. <br/><br/>

                <strong style={{color:"white"}}>Service Providers</strong> <br/><br/>
                we may employ third-party companies and individuals due to the following 
                reasons: <br/><br/>
                To facilitate our Service; 
                To provide the Service on our behalf; 
                • To perform Service-related services; or 
                • To assist us in analyzing how our Service is used. 
                we want to inform users of this Service that these third parties have access to 
                their Personal Information. The reason is to perform the tasks assigned to 
                them on our behalf. However, they are obligated not to disclose or use the 
                information for any other purpose. <br/><br/>

                <strong style={{color:"white"}}>Security</strong> <br/><br/>
                we value your trust in providing us your Personal Information, thus we are 
                striving to use commercially acceptable means of protecting it. But remember 
                that no method of transmission over the internet, or method of electronic 
                storage is 100% secure and reliable, and we cannot guarantee its absolute security. <br/><br/>

                <strong style={{color:"white"}}>Links to Other Sites </strong> <br/><br/>

                This Service may contain links to other sites. If you click on a third-party link, 
                you will be directed to that site. Note that these external sites are not 
                operated by us. Therefore, we strongly advise you to review the Privacy Policy 
                of these websites. We have no control over and assume no responsibility for the 
                content, privacy policies, or practices of any third-party sites or services. <br/><br/>

                <strong style={{color:"white"}}>Changes to This Privacy Policy </strong> <br/><br/>

                We may update our Privacy Policy from time to time. Thus, you are advised to 
                review this page periodically for any changes. We will notify you of any changes 
                by posting the new Privacy Policy on this page. 
                This policy is effective as of 2023-03-03. 
              </p>
            </div>


<div className="terms">
  <h2 style={{color:"white"}}>Terms and Conditions</h2> <br/><br/>
  <p>
  By using the app, these terms will automatically apply to you,
 you should make sure therefore that you read them carefully before using 
the app. You're not allowed to copy or modify the app, any part of the app, or 
our trademarks in any way. You're not allowed to attempt to extract the 
source code of the app, and you also shouldn't try to translate the app into 
other languages or make derivative versions. The app itself, and all the 
trademarks, copyright, database rights, and other intellectual property rights 
related to it, still belong to the HBR Team. 
The HBR Team is committed to ensuring that the app is 
as useful and efficient as possible. For that reason, we reserve the right to 
make changes to the app or to charge for its services, at any time and for any 
reason. We will never charge you for the app or its services without making it 
very clear to you exactly what you're paying for. 
The Horemow Book Reader app stores and processes personal data that you 
have provided to us, to provide our Service. It's your responsibility to keep your 
phone and access to the app secure. We therefore recommend that you do 
not jailbreak or root your phone, which is the process of removing software 
restrictions and limitations imposed by the official operating system of your 
device. It could make your phone vulnerable to malware/viruses/malicious 
programs, compromise your phone's security features and it could mean that 
the Horemow Book Reader app won't work properly or at all. <br/><br/>

<em style={{color:"white"}}>User Generated Content</em> <br/><br/>
Some features of the App allow user generated contents such as sending of comments and posting images.  
To regulate such contents, the following must be avoided: Hate Speeches, sexual contents, promotion of spams,
 illegal drug contents and other contents which may be unfit in a Chat or comment. Users who fail to adhere to the terms of 
 use will be blocked and disallowed from the Chat Room. You will be required to register or create an account for identification purposes.
  By Signing into the Chat Room you are accepting and acknowledge reading the Terms of Use.  
  We have the right to terminate or block any user who do not comply with the following terms of use. <br/><br/>

<em style={{color:"white"}}>Changes to This Terms and Conditions </em> <br/><br/>
We may update our Terms and Conditions from time to time. Thus, you are 
advised to review this page periodically for any changes. We will notify you of 
any changes by posting the new Terms and Conditions on this page. 
These terms and conditions are effective as of 2022-03-03.


  </p>
</div>

</div>

      
      );
}
export default AboutPage;